<template>
  <div class="bottom" :style="{ left: marginLeft / 2 - 110 + 'px' }">
    <div class="dwgbutton">
      <div class="operButton" :title="item.name"
        :class="{'active':item.isActive, 'hoverActive':item.hoverActive}"
        v-for="(item,index) in operList" :key="item.query" 
        @click.stop="openFun(item,index)" 
        @mouseover="mouseover(item)" @mouseleave="mouseleave(item)">
          <img :src="item.icon1" alt="图标" class="mainImage" v-if="item.isActive || item.hoverActive" srcset="">
          <img :src="item.icon" alt="图标" class="mainImage" v-else srcset="">
          <img src="./../images/dwgImage/markOn.png" alt="角标" v-if="markLogo && item.hasMark" class="mark" >
          <img src="./../images/dwgImage/markOff.png" alt="角标" v-else-if="!markLogo && item.hasMark" class="mark" >
      </div>
      <div class="measureFunc" v-show="markLogo">
        <span v-for="item in measureFuncList" :class="{'isActiveMList':item.isActive}" class="mList" :key="item.query" @click="measureActFun(item)">
          <span class="iconRed" :class="{'active':item.isActive}"></span>
          <img :src="item.icon" :title="item.name" alt="" srcset="">
          <span>{{item.name}}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'dwgButton',
  data(){
    return{
      operList: [
        { name: "框选放大", icon: require("./../images/dwgImage/框选放大.png"), icon1: require("./../images/dwgImage/框选放大s.png"), query: "amplifications", isActive: false, hoverActive: false },
        { name: "测量", icon: require("./../images/dwgImage/测量.png"), icon1: require("./../images/dwgImage/测量s.png"), query: "meaure", isActive: false, hoverActive: false,hasMark:true },
        { name: "创建批注", icon: require("./../images/dwgImage/创建批注.png"), icon1: require("./../images/dwgImage/创建批注s.png"), query: "issue", isActive: false, hoverActive: false },
      ],
      measureFuncList:[
        { name: "距离测量", icon: require("./../images/dwgImage/距离测量.png"), query: "distance", isActive: false},
        { name: "面积测量", icon: require("./../images/dwgImage/面积测量.png"), query: "area", isActive: false},
        { name: "角度测量", icon: require("./../images/dwgImage/角度测量.png"), query: "Angle", isActive: false},
        { name: "清除测量", icon: require("./../images/dwgImage/清除测量.png"), query: "cancel", isActive: false},
      ],
      markLogo:false,
      marginLeft: document.body.clientWidth / 2
    }
  },
  mounted(){
    if(this.$route.query.noNeedIssue){
      this.operList = this.operList.filter(ele=>ele.name!=="创建批注" && ele.name!=="批注列表")
    }
  },
  methods:{
    mouseover(item){
      item.hoverActive = true
    },
    mouseleave(item){
      item.hoverActive = false
    },
    //按钮点击事件
    openFun(item){
      this.operList.forEach(ele=>{
        if( ele.query == item.query ){
          item.isActive = !item.isActive
        }else{
          ele.isActive = false;
        }
      })
      Monge.Map.Measure.deactive();//关闭测量
      Monge.Map.Zoom.deactive();//关闭框选
      Monge.Map.CloudNotation.clear();
      Monge.Map.Annotation.clear();
      Monge.Map.Annotation.deactive()
      this.markLogo = false;//关闭测量
      // this.$parent.$refs.dwgLayer.close()//关闭图层
      // this.$parent.$refs.addNotation.closeAdd();
      // this.$parent.$refs.listNotation.closeList()
      // this.$parent.$refs.detailNotation.closeArea()
      switch (item.query){
        //框选放大
        case "amplifications" :
          if (item.isActive) {
            Monge.Map.Zoom.active({
              continuous: false,
              callback:(type)=>{
                if(type === Monge.CallbackType.DONE){
                  item.isActive = !item.isActive
                }
              }
            })
          }
          break;
        //测量
        case "meaure" :
          if (item.isActive) {
            this.measureFuncList.forEach(ele=>ele.isActive = false)
            this.markLogo = true;
          }
          break;
        case "issue" :
          if (item.isActive) {
            this.$parent.$refs.addDwgNotation.showAdd()
            item.isActive = !item.isActive
          }
          break;
      }
    },
    measureActFun(item){
      this.measureFuncList.forEach(ele=>{
        if( ele.query == item.query ){
          item.isActive = !item.isActive
        }else{
          ele.isActive = false;
        }
      })
      Monge.Map.Measure.deactive();//关闭测量
      switch (item.query){
        //面积测量
        case 'area' :
          if(item.isActive){
            Monge.Map.Measure.active(Monge.Map.Measure.MeasureType.AREA, (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive
                //测量完成时回调，不返回data
              } else if (type == Monge.CallbackType.OUTPUT) {
                //测量类型为point,data为点位信息
                //测量类型为distance,data存储了两个端点和测量结果
                //测量类型为angle,data存储了三个端点和测量结果
                //测量类型为area,data存储了测量结果
              } else if (type == Monge.CallbackType.SELECT_POINT) {
                //测量进行过程中，data为图纸上当前点击的点位信息和当前测量选点的数量
              }
            });
          }
          break;
        //角度测量
        case 'Angle' :
          if(item.isActive){
            Monge.Map.Measure.active(Monge.Map.Measure.MeasureType.ANGLE, (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive
                //测量完成时回调，不返回data
              } else if (type == Monge.CallbackType.OUTPUT) {
                //测量类型为point,data为点位信息
                //测量类型为distance,data存储了两个端点和测量结果
                //测量类型为angle,data存储了三个端点和测量结果
                //测量类型为area,data存储了测量结果
              } else if (type == Monge.CallbackType.SELECT_POINT) {
                //测量进行过程中，data为图纸上当前点击的点位信息和当前测量选点的数量
              }
            });
          }
          break;
        //距离测量
        case 'distance' :
          if(item.isActive){
            Monge.Map.Measure.active(Monge.Map.Measure.MeasureType.DISTANCE, (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive
                //测量完成时回调，不返回data
              } else if (type == Monge.CallbackType.OUTPUT) {
                //测量类型为point,data为点位信息
                //测量类型为distance,data存储了两个端点和测量结果
                //测量类型为angle,data存储了三个端点和测量结果
                //测量类型为area,data存储了测量结果
              } else if (type == Monge.CallbackType.SELECT_POINT) {
                //测量进行过程中，data为图纸上当前点击的点位信息和当前测量选点的数量
              }
            });
          }
          break;
        //清除测量
        case 'cancel' :
          if(item.isActive){
            Monge.Map.Measure.clear();
            item.isActive = !item.isActive
          }
          break;

      }
    },
  }

}
</script>

<style lang="scss" scoped>
.bottom{
  position: absolute;
  bottom: 23px;
  left: calc(50% - 110px);
  width: 220px;
  height: 80px;
}
.measureFunc{
  position: absolute;
  bottom: 55px;
  left: 50px;
  width: 114px;
  height: 178px;
  background: rgba(0, 0, 0, 0.68);
  box-shadow: 0px 0px 8px 2px rgba(97, 110, 139, 0.78);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  .mList{
    width: 100%;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #fff;
    cursor: pointer;
    span{
      font-size: 14px;
      line-height: 38px;
    }
    .iconRed{
      width: 4px;
      height: 4px;
      border-radius: 4px;
      margin-left: 5px;
    }
    .active{
      background: #FF0000;
    }
    img{
      margin:  0 5px;
    }
  }
  .isActiveMList{
    background-color: #fff;
    background: rgba(56, 115, 254, 0.18);
  }
  .mList:hover{
    background-color: #fff;
    background: rgba(56, 115, 254, 0.18);
    // .iconRed{
    //   background: #FF0000;
    // }
  }
}
.dwgbutton{
  position: absolute;
  bottom: 23px;
  left: calc(50% - 110px);
  width: 220px;
  height: 50px;
  background: rgba(0, 0, 0, 0.68);
  box-shadow: 0px 0px 8px 2px #616E8B;
  border-radius: 4px;
  z-index: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  .operButton{
    width: 40px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .mainImage{
      cursor: pointer;
    }
    .mark{
      width: 5px;
      height: 5px;
      position: absolute;
      bottom: 18px;
      right: 0;
      cursor: pointer;
    }
  }
  
}
</style>